import { Component, OnInit } from '@angular/core';
import {
    ArmService,
    AuthenticationService,
    ConsentementsService,
    DossierMedicalService,
    EspaceClientService,
    User,
} from '@kv-common-components/kx-services';
import { FormatHelperService } from '@shared/services/format-helper.service';
import { DocumentListHelperService } from '@shared/services/document-list-helper.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-appointment-consent',
    templateUrl: 'appointment-consent.component.html',
})
export class AppointmentConsentComponent implements OnInit {
    appointmentConsentChecked = false;
    currentEspaceClient: any;
    currentUser: User;
    currentProject: any;
    listeExamen: any[] = [];
    showErrorModal = false;
    consentLoading = false;
    pageLoading = true;
    constructor(
        private authService: AuthenticationService,
        private espaceCltService: EspaceClientService,
        private consentementsService: ConsentementsService,
        private armService: ArmService,
        private dossierMedicalService: DossierMedicalService,
        private documentListHelper: DocumentListHelperService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.pageLoading = true;
        this.currentUser = this.authService.currentUserValue;
        this.espaceCltService
            .getEspaceClient(this.currentUser.idPersonne)
            .subscribe((response) => {
                this.currentEspaceClient = response;
                this.currentProject =
                    this.currentEspaceClient.listeProjetsCredits.find(
                        (projet) =>
                            projet.idProjetCredit === this.currentUser.idDossier
                    );
                this.pageLoading = false;
            });
    }

    appointmentConsentCheckBox(event) {
        this.appointmentConsentChecked = event.target.checked;
    }

    validateConsent() {
        if (!this.consentLoading) {
            this.consentLoading = true;
            this.consentementsService
                .postSaveConsentementEADE(
                    'CONSENTEMENTS_ARM',
                    this.currentEspaceClient.personne.idAia.toString(),
                    this.currentProject.idProjetCredit
                )
                .subscribe((result) => {
                    this.createPersonne();
                });
        }
    }

    createPersonne() {
        const currentPerson = this.currentEspaceClient.personne;
        const personToCreate = {
            idApiEntite: 'EMPRUNTEUR',
            idApiApporteur: this.currentEspaceClient.idApporteurPrincipal,
            idTechniqueInterne: currentPerson.idPersonne,
            civilite: currentPerson.codeCivilite === 'mister' ? 'MR' : 'MME',
            nom: currentPerson.nom,
            nomNaissance: currentPerson.nomNaissance
                ? currentPerson.nomNaissance
                : currentPerson.nom,
            prenom: currentPerson.prenom,
            dateNaissance: FormatHelperService.getDateFormatted(
                currentPerson.dateNaissance,
                'YYYY-MM-DD',
                true
            ),
            adresse1: currentPerson.adresse1,
            adresse2: currentPerson.adresse2,
            adresse3: currentPerson.adresse3,
            codePostal: currentPerson.codePostal,
            ville: currentPerson.ville,
            pays: currentPerson.codePays,
            email: currentPerson.email,
            telephone: currentPerson.telephone,
        };

        this.armService.postPersonneARM(personToCreate).subscribe((result) => {
            const idSousDossier = this.currentProject.listeEmprunteurs.find(
                (emprunteur) =>
                    emprunteur.idPersonne === currentPerson.idPersonne
            ).idSousDossier;
            this.createDossierMedical(result, idSousDossier);
        });
    }

    createDossierMedical(personne, idSousDossier) {
        this.documentListHelper
            .getMedicalDocumentsByStatus(
                this.currentEspaceClient,
                this.currentUser,
                'both'
            )
            .subscribe((responseListExam) => {
                this.armService.getTypesExamens().subscribe((typesExamens) => {
                    this.listeExamen = this.formatListExam(
                        responseListExam,
                        typesExamens
                    );
                    const dossierMedical = {
                        idApiPersonne: personne.idApi,
                        referenceDossier: idSousDossier,
                        listeExamen: this.listeExamen,
                    };

                    this.armService
                        .postDossierMedical(dossierMedical)
                        .subscribe((result) => {
                            this.consentLoading = false;
                            const idDossierMedical = result.idApi;
                            this.saveIdDossierMedical(idDossierMedical);
                        });
                });
            });
    }

    saveIdDossierMedical(idDossierMedical) {
        this.dossierMedicalService
            .postIdDossierMedical(
                this.currentEspaceClient.personne.idAia,
                this.currentProject.idProjetCredit,
                idDossierMedical
            )
            .subscribe(
                (success) => {
                    this.router.navigateByUrl(
                        '/souscription/appointment/appointment-type'
                    );
                },
                (error) => {
                    this.showErrorModal = true;
                }
            );
    }

    formatListExam(listExam: any[], typesExamens: any[]) {
        const listExamARM = [];
        listExam.forEach((currentExam) => {
            typesExamens.forEach((typeExam) => {
                if (currentExam.idApiTypeExamen === typeExam.typeEmprunteur) {
                    currentExam.idApiTypeExamen = typeExam.idApi;
                    listExamARM.push(currentExam);
                }
            });
        });
        return listExamARM;
    }
}
